import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/check", label: "Check" },
  { to: "/loads", label: "Loads" },
  { to: "/logs/fuel", label: "Logs" },
  { to: "/money", label: "Money" },
  { to: "/settings", label: "Settings" },
] as const;

export function BottomTabs() {
  return (
    <nav className="bottom-tabs" aria-label="Primary">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `nav-link${isActive ? " active" : ""}`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
